import {
    TRANSACTIONSUBTYPES_SUCCESS,
    TRANSACTIONSUBTYPES_FAILED,
    RESET_TRANSACTIONSUBTYPES,
    LOADING_TRANSACTIONSUBTYPES,
    NETWORK_ERROR_TRANSACTIONSUBTYPES
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetTransactionSubTypes = () => {
    return { type: RESET_TRANSACTIONSUBTYPES };
};

const partnerTransactionSubTypesListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_TRANSACTIONSUBTYPES });
    await partnerServices
        .post("transactionSubTypes", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerTransactionSubTypessuccess(res.data));
                    break;
                default:
                    dispatch(partnerTransactionSubTypesFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_TRANSACTIONSUBTYPES,
                payload: err
            });
        });
};

function partnerTransactionSubTypessuccess(data) {
    return {
        type: TRANSACTIONSUBTYPES_SUCCESS,
        payload: data,
    };
}

function partnerTransactionSubTypesFailed(data) {
    return {
        type: TRANSACTIONSUBTYPES_FAILED,
        payload: data,
    };
}

export { resetTransactionSubTypes, partnerTransactionSubTypesListReq }